<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Usuarios</a>
  </div>
  <h1 class="ui header"><i class="icon users"></i>
    <div class="content">Usuarios</div>
  </h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/users/add')">
    <i class="icon user"></i>Añadir Usuario
  </button>
  <div v-if="!users" class="ui active centered inline loader"></div>
  <div v-if="users" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing  table">
          <thead>
            <tr>
              <th class="azpian">Nombre</th>
              <th class="azpian">Username</th>
              <th class="azpian">Compañia</th>
              <th class="azpian">Activo</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar usuario" @change="filteredList">
                    <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.Administrator.id">
              <td>
                <h4 class="ui image header">
                  <img class="ui mini image" src="../../assets/user.png">
                  <div class="content">
                    <div class="header">{{user.Administrator.name}}</div>
                  </div>
                </h4>
              </td>
              <td>
                {{user.Administrator.username}}
              </td>
              <td >
                <a v-on:click="goTo('/companies/edit/' + user.AdminCompany.id)"><b>{{user.AdminCompany.name}}</b></a>
              </td>
              <td>
                <h2><i v-if="user.Administrator.active" class="hapiick check icon"></i>
                  <i v-if="!user.Administrator.active" class="red times icon"></i>
                </h2>
              </td>
              <td>
                <div class="ui button" v-on:click="goTo('/users/edit/' + user.Administrator.id)">Editar</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Users',
  data() {
    return {
      users: null,
      search: null,
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin') {
      this.getUsers()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getUsers() {
      hapiickApi().post('/v2/users', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => this.users = JSON.parse(JSON.stringify(request.data.data.users)))
      .catch(() => console.log('error getting companies'))
    },
    goTo(where) {
      this.$router.push(where)
    },
    filteredList() {
      let userlist = []
      if (this.search.length == 0) {
        this.getUsers()
      }
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].Administrator.name.toLowerCase().includes(this.search.toLowerCase()))
          userlist.push(this.users[i])
      }
      this.users = userlist
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue